import { websitePaths } from 'domains/website/website.paths'

type ReplaceDynamicPaths = (path: string, ...values: string[]) => string

/**
 * Given these params: ('/[account]/[project]/', 'dummy', 'weather-app')
 * the function will return: '/dummy/weather-app'.
 *
 * @param path
 * @param values
 */
export const replaceDynamicPaths: ReplaceDynamicPaths = (path, ...values) => {
  let replacedPath = path

  values.forEach(v => {
    const substring = replacedPath.substring(
      replacedPath.indexOf('['),
      replacedPath.indexOf(']') + 1,
    )
    replacedPath = replacedPath.replace(substring, encodeURIComponent(v))
  })

  return replacedPath
}

export const getDocsPath = (path: `/${string}/${string}` | `/${string}`) =>
  websitePaths.docs + path

export const getDocsQuickStartPath = () => websitePaths.docs + '/config'
